import { apiSlice } from '@/features/api/apiSlice';

export type EspId =
  | 'resend'
  | 'mailgun'
  | 'postmark'
  | 'sendgrid'
  | 'amazonses'
  | 'mailchimp'
  | 'sparkpost'
  | 'unknown';

export type DetectResult = {
  domain: string;
  mx: string[];
  spf: string | null;
  inferredEsp: EspId;
  inferredEspName: string;
  inferredEspSupported: boolean;
  signupUrl: string;
  candidates: Array<{ id: EspId; name: string; hits: number; supported: boolean }>;
};

export type DnsInstruction = {
  type: 'TXT' | 'CNAME' | 'MX';
  host: string;
  value: string;
  note?: string;
  category: string;
};

export type DnsVerifyResult = {
  domain: string;
  spf: { status: 'verified' | 'missing' | 'invalid'; value: string | null };
  dkim: { status: 'verified' | 'missing' | 'invalid'; value: string | null };
  dmarc: { status: 'verified' | 'missing' | 'invalid'; value: string | null };
};

export const smtpOnboardApi = apiSlice.injectEndpoints({
  endpoints: (b) => ({
    detectSmtp: b.mutation<DetectResult, { domain: string }>({
      query: (body) => ({ url: '/smtp-onboard/detect', method: 'POST', body }),
    }),
    smtpDnsInstructions: b.mutation<DnsInstruction[], { domain: string; providerType: EspId }>({
      query: (body) => ({ url: '/smtp-onboard/dns-instructions', method: 'POST', body }),
    }),
    verifySmtpDns: b.mutation<DnsVerifyResult, { domain: string; providerType: EspId }>({
      query: (body) => ({ url: '/smtp-onboard/verify', method: 'POST', body }),
    }),
  }),
});

export const {
  useDetectSmtpMutation,
  useSmtpDnsInstructionsMutation,
  useVerifySmtpDnsMutation,
} = smtpOnboardApi;
